<template>
  <banner
    v-if="activePromotionName"
    :id="activePromotionName"
    :show="true"
    type="notification"
    :content="content"
    event-category="header-20190814-promotion_alert"
    :cookie="cookie"
    :modifiers="['sale']" />
</template>

<script>
import { mapGetters } from "vuex";
import Banner from "./banner";

export default {
  name: "SaleBanner",
  components: {
    Banner
  },
  computed: {
    ...mapGetters("sales", ["activePromotionName", "content", "cookie"])
  }
};
</script>
